import React from 'react';

const icons = {
  erp: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  wms: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4M4 7l8 4M4 7v10l8 4m0-10v10" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
  mobile: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="2" width="14" height="20" rx="3" stroke="currentColor" strokeWidth="1.5" />
      <line x1="12" y1="18" x2="12" y2="18.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  devops: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2v4m0 12v4M2 12h4m12 0h4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
};

const Features = () => {
  const features = [
    {
      id: 1,
      title: 'Sistemas ERP',
      description:
        'Soluções de gestão empresarial personalizadas para otimizar processos e aumentar a produtividade.',
      icon: 'erp',
    },
    {
      id: 2,
      title: 'Sistemas WMS',
      description:
        'Gestão de armazéns inteligente para controle de estoque preciso e operações logísticas eficientes.',
      icon: 'wms',
    },
    {
      id: 3,
      title: 'Aplicações Mobile',
      description:
        'Desenvolvimento de aplicações sob medida para necessidades específicas do seu negócio.',
      icon: 'mobile',
    },
    {
      id: 4,
      title: 'Consultoria DevOps',
      description:
        'Infraestrutura e pipelines otimizados para entregas contínuas com segurança e escalabilidade.',
      icon: 'devops',
    },
  ];

  return (
    <section id="recursos" className="features-section">
      <div className="features-inner">
        <div className="features-header">
          <p className="section-label">O que fazemos</p>
          <h2 className="section-title">{"Nossos Serviços"}</h2>
          <p className="section-subtitle" style={{ marginTop: '0.75rem' }}>
            {"Soluções personalizadas para desafios complexos"}
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature) => (
            <div key={feature.id} className="feature-card fade-in-up">
              <div className="feature-icon">{icons[feature.icon]}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
              <img
                src={`/images/imageFeatures${feature.id}.webp`}
                alt={feature.title}
                className="feature-image"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
